import './navbarcheck.css'

const NavbarCheck = () => {
    return ( 
        <div className="navbar-check d-flex justify-content-center align-items-center">
             <div className="row " style={{ width:'95dvw', height:'100%'}}>
                <div className="col  ">
                    <p className='text-profile d-flex justify-content-center align-items-center'> Checkout </p>
                </div>
            </div>
        </div>
     );
}
 
export default NavbarCheck;